import $ from 'jquery';

$(document).ready(() => {
  $('.teaser--video .teaser__video, .teaser--video.teaser--video--only-play').on('click', (event) => {
    const $el = $(event.delegateTarget);
    event.stopPropagation();
    event.preventDefault();

    $.fancybox.open({
      src: $el.data('video-url'),
      type: 'iframe',
    });
  });
  $('a.fancybox-media').fancybox();
});



// WEBPACK FOOTER //
// ./assets/js/components/fancybox.js